/* FAQ — GSAP entry animations + scroll spy */
(function () {
  function init() {
    if (typeof window.gsap === 'undefined') return setTimeout(init, 60);
    if (typeof window.ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(window.ScrollTrigger);
    }

    document.querySelectorAll('.faq-page').forEach((root) => {
      // Hero entrance
      const heroEls = [
        root.querySelector('.faq-hero__label'),
        root.querySelector('.faq-hero__heading'),
        root.querySelector('.faq-hero__rule'),
        root.querySelector('.faq-hero__subtext'),
        root.querySelector('.faq-hero__aside'),
      ].filter(Boolean);

      gsap.fromTo(heroEls,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out', stagger: 0.12, delay: 0.15 }
      );

      // Content reveal
      const sidebar = root.querySelector('.faq-content__sidebar');
      if (sidebar) {
        gsap.fromTo(sidebar,
          { opacity: 0, y: 20 },
          {
            opacity: 1, y: 0, duration: 0.9, ease: 'power2.out',
            scrollTrigger: { trigger: sidebar, start: 'top 88%', once: true },
          }
        );
      }

      root.querySelectorAll('.faq-group').forEach((group) => {
        gsap.fromTo(group,
          { opacity: 0, y: 28 },
          {
            opacity: 1, y: 0, duration: 0.9, ease: 'power2.out',
            scrollTrigger: { trigger: group, start: 'top 88%', once: true },
          }
        );
      });

      // Help CTA
      root.querySelectorAll('.faq-help__inner > *').forEach((el, i) => {
        gsap.fromTo(el,
          { opacity: 0, y: 24 },
          {
            opacity: 1, y: 0, duration: 0.9, delay: i * 0.08, ease: 'power2.out',
            scrollTrigger: { trigger: el, start: 'top 90%', once: true },
          }
        );
      });

      // Scroll spy for category nav
      const navLinks = root.querySelectorAll('[data-faq-nav]');
      const groups = root.querySelectorAll('[data-faq-group]');
      if (navLinks.length && groups.length && window.ScrollTrigger) {
        groups.forEach((group) => {
          ScrollTrigger.create({
            trigger: group,
            start: 'top 40%',
            end: 'bottom 40%',
            onToggle: (self) => {
              if (self.isActive) {
                const id = group.getAttribute('data-faq-group');
                navLinks.forEach((l) => l.classList.toggle('is-active', l.getAttribute('data-faq-nav') === id));
              }
            },
          });
        });
      }

      // Smooth scroll for category links
      navLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;
          const target = document.querySelector(href);
          if (!target) return;
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      });

      // Single-open accordion behavior (within each group)
      root.querySelectorAll('.faq-group__items').forEach((groupItems) => {
        const items = groupItems.querySelectorAll('details.faq-item');
        items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (item.open) {
              items.forEach((other) => {
                if (other !== item) other.open = false;
              });
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
